import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    formatted
  } = useCountdown(24, 0, 0);
  return <div className="sticky top-0 z-50 bg-lsa-cyan text-lsa-deep py-1.5 px-4 text-center text-[11px] sm:text-xs font-semibold shadow-md" data-id="element-305">
      <p data-id="element-306">
        ⏰ Temporizador de oferta 24h ·{' '}
        <span className="font-bold tracking-wider" data-id="element-307">{formatted}</span>
      </p>
    </div>;
}